<template>
  <b-modal id="modal-precheckinfacerecognition" modal-class="modal-mobile-fullscreen modal-face-checkin" centered
           @shown="show"
           @hidden="reset" size="md" no-close-on-backdrop>
    <template v-slot:modal-header>
      <h1 class="modal-title modal-title--small m-0"
          v-if="(!faceImgTaken && viewState === modalStates.STATE_CAMERA) || (!faceImgLivenessTaken && livenessDetectionEnabled && takeLivenessSelfie)">
        <template v-if="checkinFaces.length >= 1">
          {{ $t('modal_pre_checkin_face_recognition.photo_step.title_multi') }}
        </template>
        <template v-else>
          {{ $t('modal_pre_checkin_face_recognition.photo_step.title') }}
        </template>
      </h1>
      &nbsp;
      <h1 class="modal-title modal-title--small m-0"
          v-if="(faceImgTaken && !livenessDetectionEnabled) || (faceImgTaken && livenessDetectionEnabled && !takeLivenessSelfie) || (faceImgTaken && faceImgLivenessTaken)">
        {{ $t('modal_pre_checkin_face_recognition.photo_step.title2') }} </h1>
      <b-link v-if="showModalCloser" @click="$bvModal.hide('modal-precheckinfacerecognition')" class="close-label">
        {{ $t('modal_pre_checkin_face_recognition.btn_cancel') }}
      </b-link>
    </template>
    <div class="d-block text-center dates-selector" v-if="showRangeDateSelector">
      <h3 class="modal-title mb-2">
        {{ stepData.event_name }}
      </h3>
      <div class="mb-3">
        <h5 class="modal-subtitle" v-if="isSameDayStay">
          {{ $t('modal_pre_checkin_face_recognition.ask_date_step.subtitle_same_day') }}
        </h5>
        <h5 class="modal-subtitle" v-else-if="showRangeDateSelector">
          {{ $t('modal_pre_checkin_face_recognition.ask_date_step.subtitle_start') }}
        </h5>
      </div>
      <multiselect v-if="showEndDateOnlySelector"
                   v-model="faceValidityEndDate"
                   :options="faceValidityEndDateOptions"
                   :placeholder="$t('modal_pre_checkin_face_recognition.ask_date_step.select_placeholder')"
                   :allow-empty="false"
                   :close-on-select="true"
                   :clear-on-select="false"
                   :preserve-search="true"
                   label="label"
                   track-by="value"
                   :show-labels="false"
                   :preselect-first="true"
                   class="mb-3">
      </multiselect>
      <div v-else class="d-flex flex-column mx-4">
        <div class="dates-selector__choice" v-if="!isSameDayStay">
          <span>{{ faceValidityStartDate | formatDate }} - {{ faceValidityEndDate | formatDate }}</span>
          <img :src="require('@/assets/event_owner/default/icons/calendar.svg')">
        </div>
        <!-- START DATE -->
        <div class="dates-selector__calendar" v-if="showRangeDateSelector">
          <span class="text-danger d-block mt-2" v-if="faceValidityStartDateError">
              {{ $t('modal_pre_checkin_face_recognition.ask_date_step.datepicker_error') }}
          </span>
          <input type="text" id="datepicker-trigger-start" class="d-none" placeholder="Select dates">

          <AirbnbStyleDatepicker class="align-self-center"
                                 :trigger-element-id="'datepicker-trigger-start'"
                                 :mode="isSameDayStay?'single':'range'"
                                 :fullscreen-mobile="false"
                                 :inline="true"
                                 :months-to-show="1"
                                 :min-date="minDate"
                                 :end-date="endDate"
                                 :show-action-buttons="false"
                                 :show-shortcuts-menu-trigger="false"
                                 :date-one="faceValidityStartDate"
                                 :date-two="faceValidityEndDate"
                                 @date-one-selected="val => { faceValidityStartDate = val }"
                                 @date-two-selected="val => { faceValidityEndDate = val }">
            <template v-slot:previous-month-icon>
              <img width="20px" :src="require('@/assets/event_owner/default/icons/chevron-left.svg')">
            </template>
            <template v-slot:next-month-icon>
              <img width="20px" :src="require('@/assets/event_owner/default/icons/chevron-right.svg')">
            </template>
          </AirbnbStyleDatepicker>
        </div>

        <div class="dates-selector__info" v-if="showRangeDateSelector">
          {{ $t('modal_pre_checkin_face_recognition.ask_date_step.dates_info') }}
        </div>
      </div>

    </div>

    <div class="d-block text-center" v-else-if="viewState === modalStates.STATE_DATES_SUMMARY">
      <div class="mx-4">
        <h4 class="modal-title mb-2">
          {{ $t('modal_pre_checkin_face_recognition.ask_date_step.dates_confirm') }}
        </h4>

        <div class="mb-4">
          <h6 class="modal-subtitle">{{
              $t('modal_pre_checkin_face_recognition.ask_date_step.dates_summary_title')
            }}</h6>
          <span>{{ faceValidityStartDate | formatDate }} <span
              v-if="faceValidityEndDate">-</span> {{ faceValidityEndDate | formatDate }}</span>
        </div>
      </div>
    </div>

    <div class="d-block text-center"
         v-else-if="viewState === modalStates.STATE_CAMERA || viewState === modalStates.STATE_ASK_LIVENESS_SELFIE">

      <WebcamStreamFace @photoTaken="onPhotoTaken($event)" ref="faceDetector"
                        @photoRetake="onPhotoRetake"
                        @streamNotAllowed="onStreamNotAllowed"
                        @streamAllowed="onStreamAllowed"
                        :default-camera="checkinFaces.length >= 1 ? 'environment' : 'user'"
                        :taking-selfie="takingSelfie" v-if="!livenessDetectionEnabled"/>

      <WebcamStreamFaceDetectorLiveness @photoTaken="onPhotoTaken($event)" ref="faceDetector"
                                        :is-liveness="takeLivenessSelfie"
                                        :force-resume-video="forceResumeVideo"
                                        :default-camera="checkinFaces.length >= 1 ? 'environment' : 'user'"
                                        :is-countdown-enabled="takingSelfie"
                                        @streamNotAllowed="onStreamNotAllowed"
                                        @streamAllowed="onStreamAllowed"
                                        v-else-if="livenessDetectionEnabled"/>

      <div class="text-left text-info-selfie position-relative"
           v-if="(faceImgTaken && !livenessDetectionEnabled) || (faceImgTaken && faceImgLivenessTaken && livenessDetectionEnabled)"
           @click="onPrivacyLinkClick">
        <!-- EXTRA SELFIE UPLOAD -->
        <template v-if="checkin">
          <b-form-checkbox v-model="acceptPrivacySelfie"
                           name="consent_privacy_and_terms"
                           :value="true"
                           :unchecked-value="false">
            <span class="face-privacy" v-html="privacyMultiSelfie"></span>
            <div class="privacy-blur"></div>
          </b-form-checkbox>
        </template>
        <template v-else-if="privacy && privacy.enabled">
          <!-- Se ci sono checkbox, ordine: share_policy -> privacy -> share_policy2 -> share_policy3 -->
          <template v-if="privacy.show_share_policy_checkbox || privacy.show_privacy_checkbox">
            <template v-if="privacy.show_share_policy_checkbox">
              <b-form-checkbox v-model="consentShareDataWithOwner"
                               name="consent_share_data_with_owner"
                               :value="true"
                               :unchecked-value="false">
                <span class="face-privacy" v-html="privacy.share_policy_text"></span>
              </b-form-checkbox>
            </template>
            <template v-if="privacy.show_privacy_checkbox">
              <b-form-checkbox v-model="acceptPrivacySelfie"
                               name="consent_privacy_and_terms"
                               :value="true"
                               :unchecked-value="false">
                <span class="face-privacy" v-html="privacy.privacy_policy_text"></span>
                <div class="privacy-blur"></div>
              </b-form-checkbox>
            </template>
            <!-- Share Policy 2 -->
            <template v-if="privacy.share_policy2_type && privacy.share_policy2_type !== 'none'">
              <b-form-checkbox v-model="acceptSharePolicy2"
                               name="consent_share_policy2"
                               :value="true"
                               :unchecked-value="false">
                <span class="face-privacy" v-html="privacy.share_policy2_text"></span>
                <div class="privacy-blur"></div>
              </b-form-checkbox>
            </template>
            <!-- Share Policy 3 -->
            <template v-if="privacy.share_policy3_type && privacy.share_policy3_type !== 'none'">
              <b-form-checkbox v-model="acceptSharePolicy3"
                               name="consent_share_policy3"
                               :value="true"
                               :unchecked-value="false">
                <span class="face-privacy" v-html="privacy.share_policy3_text"></span>
                <div class="privacy-blur"></div>
              </b-form-checkbox>
            </template>
          </template>
          
          <!-- Se NON ci sono checkbox, ordine: share_policy2 -> share_policy3 -> testo -->
          <template v-else>
            <!-- Share Policy 2 -->
            <template v-if="privacy.share_policy2_type && privacy.share_policy2_type !== 'none'">
              <b-form-checkbox v-model="acceptSharePolicy2"
                               name="consent_share_policy2"
                               :value="true"
                               :unchecked-value="false">
                <span class="face-privacy" v-html="privacy.share_policy2_text"></span>
                <div class="privacy-blur"></div>
              </b-form-checkbox>
            </template>
            <!-- Share Policy 3 -->
            <template v-if="privacy.share_policy3_type && privacy.share_policy3_type !== 'none'">
              <b-form-checkbox v-model="acceptSharePolicy3"
                               name="consent_share_policy3"
                               :value="true"
                               :unchecked-value="false">
                <span class="face-privacy" v-html="privacy.share_policy3_text"></span>
                <div class="privacy-blur"></div>
              </b-form-checkbox>
            </template>
            <!-- Testo senza checkbox -->
            <span v-html="privacy.privacy_policy_text"></span>
          </template>

        </template>
      </div>
    </div>


    <div class="d-block text-center" v-else-if="viewState === modalStates.STATE_ASK_EXTRA_SELFIE_UPLOAD">
      <h1 class="modal-title pb-2 px-4">
        {{ $t('modal_pre_checkin_face_recognition.ask_additional_selfie.title') }}
      </h1>
      <h4 class="modal-subtitle pb-2 px-4">
        {{ $t('modal_pre_checkin_face_recognition.ask_additional_selfie.subtitle') }} </h4>
      <hr>
      <CheckinFaceList @click="nextStep()" :checkin-faces="checkinFaces"
                       :max-faces-count="stepData.max_faces_count"/>
      <hr>
    </div>

    <div class="d-block text-center px-4 mb-4" v-else-if="viewState === modalStates.STATE_INFO">
      <Icon name="grFileSearch" width="26" class="mb-2"/>
      <h1 class="modal-title mb-2"> {{ $t('modal_pre_checkin_face_recognition.info_step.title') }} </h1>
      <h4 class="modal-subtitle"> {{ $t('modal_pre_checkin_face_recognition.info_step.subtitle') }} </h4>
    </div>
    <div class="d-block text-center px-4" v-else>
      <ViewLoader :padding-classes="'py-1'"/>
    </div>

    <template v-slot:modal-footer>
      <template v-if="viewState === modalStates.STATE_CAMERA">
        <template v-if="!takingSelfie || (!faceImgTaken && takingSelfie)">
          <b-link class="switch-camera-btn rounded-circle mx-1" :disabled="photoHasError || detecting"
                  @click="onCameraSwitch()"
                  v-if="checkinFaces.length >= 1">
            <Icon name="reload" width="30"/>
          </b-link>&nbsp;
          <b-link class="bt-shoot" @click="nextStep()"
                  :disabled="photoHasError || detecting || !streaming">
            <Icon name="cameraShutter" width="70"/>
          </b-link>
        </template>

        <template v-else-if="faceImgTaken">
          <div class="row w-100 justify-content-center">
            <div class="col-sm-6 order-sm-1 mb-2 mb-sm-0">
              <button-with-spinner class="btn btn-primary btn-block"
                                   @click="beforeConfirm()"
                                   :disabled="confirmSelfieDisabled"
                                   :loading="loading">
                {{ $t('modal_pre_checkin_face_recognition.btn_confirm') }}
              </button-with-spinner>
            </div>
            <div class="col-sm-6 order-sm-0">
              <b-button variant="light" block @click="onPhotoRetake()" class="text-nowrap">
                {{ $t('modal_pre_checkin_face_recognition.photo_step.retake_photo') }}
              </b-button>
            </div>
          </div>
        </template>

      </template>
      <template v-else-if="viewState === modalStates.STATE_ASK_LIVENESS_SELFIE">
        <b-link class="bt-shoot" @click="nextStep()"
                v-if="!takingSelfie"
                :disabled="takingSelfie">
          <Icon name="cameraShutter" width="70"/>
        </b-link>
        <button-with-spinner class="btn btn-primary btn-block" v-else
                             @click="confirm()"
                             :disabled="faceImgLivenessTaken === null"
                             :loading="loading">
          {{ $t('modal_pre_checkin_face_recognition.btn_next') }}

        </button-with-spinner>

      </template>
      <template v-else-if="viewState === modalStates.STATE_ASK_EXTRA_SELFIE_UPLOAD">
        <b-button variant="primary" block @click="nextStep()">
          {{ $t('modal_pre_checkin_face_recognition.ask_additional_selfie.btn_next') }}
        </b-button>
        <b-button variant="ghost" block @click="prevStep()">
          {{ $t('modal_pre_checkin_face_recognition.ask_additional_selfie.btn_back') }}
        </b-button>

      </template>
      <template v-else-if="viewState">
        <div class="row w-100 justify-content-center">
          <div class="order-sm-1 mb-2 mb-sm-0"
               :class="[viewState !== modalStates.STATE_ASK_VALIDITY_RANGE_DATE ? 'col-sm-6' : 'col-sm-12']">
            <b-button variant="primary" block @click="nextStep()" :disabled="isDisabledButtonDate || loading">
              {{ $t('modal_pre_checkin_face_recognition.btn_next') }}
            </b-button>
          </div>
          <div class="col-sm-6 order-sm-0" v-if="showPrevStepButton">
            <b-button variant="light" block @click="prevStep()">
              <template v-if="viewState === modalStates.STATE_DATES_SUMMARY">
                {{ $t('modal_pre_checkin_face_recognition.ask_date_step.back_to_dates') }}
              </template>
              <template v-else>
                {{ $t('modal_pre_checkin_face_recognition.btn_back') }}
              </template>
            </b-button>
          </div>
        </div>
        <div class="row" v-if="viewState === modalStates.STATE_INFO">
          <div class="col">
            <p class="modal-text text-center my-3">
              {{ $t('modal_pre_checkin_face_recognition.info_step.privacy_info') }}
            </p>
          </div>
        </div>
      </template>
      <template v-else>&nbsp;</template>
    </template>

    <ModalPolicyText v-if="isSsoUser" ref="policyModal" modal-id="bv-modal-policy-facerec"/>
  </b-modal>
</template>


<script>
import Multiselect from "vue-multiselect"
import ButtonWithSpinner from "@/components/ButtonWithSpinner"
import CheckinFaceList from "@/components/CheckinFaceList"
import {getBrowserLanguage} from "@/i18n";
import WebcamStreamFaceDetectorLiveness from "@/components/WebcamStreamFaceDetectorLiveness.vue";
import ViewLoader from "@/components/ViewLoader.vue";
import {mapGetters, mapActions} from "vuex";
import {NextStepRequired} from "@/domain/autologin/exceptions";
import WebcamStreamFace from "@/components/WebcamStreamFace.vue";
import ModalPolicyText from "@/components/ModalPolicyText.vue";
import {policyUrl} from "@/utils";
import moment from "moment/moment";
import {checkinErrors} from "@/consts";
import {isNavigationFailure} from "vue-router";

const stayMode = {
  NONE: 'none',
  ONLY_END: 'only-end',
  SAME_DAY: 'same-day',
  START_END: 'start-end'
}

export default {
  components: {
    WebcamStreamFace,
    ViewLoader,
    WebcamStreamFaceDetectorLiveness,
    ButtonWithSpinner,
    CheckinFaceList,
    Multiselect,
    ModalPolicyText,
  },

  data() {
    return {
      modalStates: {
        STATE_ASK_EXTRA_SELFIE_UPLOAD: 'ask_extra_selfie_upload',
        STATE_ASK_VALIDITY_RANGE_DATE: 'ask_expiration_start_date',
        //STATE_ASK_VALIDITY_END_DATE: 'ask_expiration_end_date',
        STATE_ASK_LIVENESS_SELFIE: 'ask_liveness_selfie',
        STATE_DATES_SUMMARY: 'dates_summary',
        STATE_INFO: 'info',
        STATE_CAMERA: 'camera',
        STATE_STAY_MODE: ''
      },
      viewState: undefined,
      faceValidityStartDate: null,
      faceValidityEndDate: null,
      faceValidityEndDateOptions: [],

      faceValidityStartDateError: false,
      takingSelfie: false,
      detecting: false,
      faceImgTaken: null,
      faceImgLivenessTaken: null,
      forceResumeVideo: false,
      checkin: null,
      checkinFaces: [],

      faceCheckinComplete: false,
      loading: false,
      backBtnOnCameraViewDisabled: false,
      wasCameraPermissionGrantedWhenOpened: false,

      acceptPrivacySelfie: false,
      acceptSharePolicy2: false,
      acceptSharePolicy3: false,
      photoHasError: false,
      consentShareDataWithOwner: false,

      streaming: false
    }
  },


  computed: {
    ...mapGetters('checkin', [
      'stepData', 'privacy'
    ]),
    ...mapGetters('auth', ['isSsoUser']),
    ...mapGetters(['thirdLevelDomain', "startOfStay", "endOfStay"]),
    minDate() {
      const today = new Date()
      return new Date(today.setDate(today.getDate() - 180))
    },
    endDate() {
      const today = new Date()
      return new Date(today.setDate(today.getDate() + 30))
    },
    isDisabledButtonDate() {
      if (this.viewState === this.modalStates.STATE_ASK_VALIDITY_RANGE_DATE) {
        if (this.isSameDayStay) {
          return !(this.faceValidityStartDate)
        }
        return !(this.faceValidityStartDate && this.faceValidityEndDate)
      }
      return false
    },
    privacyMultiSelfie() {
      return this.$t('modal_pre_checkin_face_recognition.photo_step.info_multi_selfie',
          {privacy_url: this.policyUrl().privacy})
    },
    confirmSelfieDisabled() {
      if (this.faceImgTaken === null) return true
      else if (this.privacy && this.privacy.show_privacy_checkbox && !this.acceptPrivacySelfie) return true
      else if (this.privacy && this.privacy.share_policy2_type === 'mandatory' && !this.acceptSharePolicy2) return true
      else if (this.privacy && this.privacy.share_policy3_type === 'mandatory' && !this.acceptSharePolicy3) return true
      else if (this.checkin && !this.acceptPrivacySelfie) return true
      else return false
    },

    showPrevStepButton() {
      return this.viewState !== this.modalStates.STATE_ASK_VALIDITY_RANGE_DATE && this.viewState !== this.modalStates.STATE_INFO
    },
    showModalCloser() {
      if (this.viewState === this.modalStates.STATE_INFO) {
        return false
      }
      return !this.$store.getters['appConfig/isRunningInWebview'] && !this.$store.state.isPreviewCheckin
    },
    firstEndDateAvailable() {
      if (this.faceValidityStartDate) {
        let date = new Date(this.faceValidityStartDate);
        return new Date(date.setDate(date.getDate())).toISOString().substring(0, 10);
      } else {
        return null
      }
    },
    showRangeDateSelector() {
      return this.viewState === this.modalStates.STATE_ASK_VALIDITY_RANGE_DATE
    },
    showEndDateOnlySelector() {
      return this.viewState === this.modalStates.STATE_ASK_VALIDITY_RANGE_DATE && this.stepData.stay_mode === this.stayMode.ONLY_END
    },
    isSameDayStay() {
      return this.stepData.stay_mode === this.stayMode.SAME_DAY
    },
    livenessDetectionEnabled() {
      return this.stepData.liveness_detection_enabled
    },
    takeLivenessSelfie() {
      return this.livenessDetectionEnabled && this.viewState === this.modalStates.STATE_ASK_LIVENESS_SELFIE
    },
    postCheckinMode() {
      return this.stepData.user_cta === 'face-checkin'
    },
  },

  created() {
    this.$bvModal.show('modal-precheckinfacerecognition')
    this.stayMode = stayMode
  },

  methods: {
    ...mapActions('checkin', [
      'resetStepData',
      'completeCheckin',
      'uploadSelfie',
      'validateStay',
      'openStepModal'
    ]),
    policyUrl,
    onPrivacyLinkClick(e) {
      if (!this.isSsoUser) return
      const anchor = e.target.closest('a')
      if (!anchor || !anchor.href) return
      e.preventDefault()
      this.$refs.policyModal.open(anchor.href, anchor.textContent.trim())
    },
    async show() {
      this.consentShareDataWithOwner = false
      this.acceptPrivacySelfie = false
      this.acceptSharePolicy2 = false
      this.acceptSharePolicy3 = false

      this.faceValidityStartDate = null
      this.faceValidityEndDate = null

      this.faceValidityStartDateError = false
      this.faceCheckinComplete = false
      // Stale flags from a previous session would keep the shutter button
      // disabled (:disabled="photoHasError || detecting || !streaming")
      this.detecting = false
      this.photoHasError = false
      this.isCameraPermissionGranted().then(granted => this.wasCameraPermissionGrantedWhenOpened = granted).catch(error => console.log(error))
      // Prefilled dates (SSO, preview, ...) skip the dates step: run the stay
      // preflight now, the modal shows its loader until viewState is set
      if (!await this.checkStayReuse()) return
      if (this.stepData.checkin) {
        this.checkin = this.stepData.checkin
        this.checkinFaces = this.stepData.checkin_faces
        this.backBtnOnCameraViewDisabled = true
        this.viewState = this.modalStates.STATE_CAMERA
      } else if (this.stepData.stay_mode && this.stepData.stay_mode !== this.stayMode.NONE) {
        // preselect dates
        if (this.startOfStay && this.endOfStay) {
          this.faceValidityStartDate = this.startOfStay
          this.faceValidityEndDate = this.endOfStay
          this.viewState = this.wasCameraPermissionGrantedWhenOpened ? this.modalStates.STATE_CAMERA : this.modalStates.STATE_INFO
        } else {
          this.viewState = this.modalStates.STATE_ASK_VALIDITY_RANGE_DATE
        }
      } else {
        if (this.$store.getters['appConfig/isRunningInWebview']) {
          this.viewState = this.modalStates.STATE_CAMERA
        } else {
          this.isCameraPermissionGranted().then(granted => {
            if (granted) {
              this.viewState = this.modalStates.STATE_CAMERA
            } else {
              this.viewState = this.modalStates.STATE_INFO
            }
          }).catch(error => console.log(error))
        }
      }
      const lang = getBrowserLanguage()
      const dateOptions = {weekday: 'long', month: 'long', day: 'numeric'}
      let options = []
      for (let i = -1; i < 20; i++) {
        let d = new Date()
        d.setDate(d.getDate() + i)
        d.setHours(23, 59, 59, 999)
        let label
        if (i === -1) {
          label = this.$t('modal_pre_checkin_face_recognition.ask_date_step.opt_already_back')
        } else if (i === 0) {
          label = this.$t('modal_pre_checkin_face_recognition.ask_date_step.opt_today')
        } else {
          label = d.toLocaleDateString(lang, dateOptions)
        }
        options.push({label: label, value: d})
      }
      this.faceValidityEndDateOptions = options
    },

    reset() {
      if (typeof this.stepData.callback === 'function') {
        this.stepData.callback(this.checkin.id, this.checkinFaces, this.faceCheckinComplete)
      } else {
        // TODO: bad fix, try something different
        if (this.checkinFaces.length > 1) {
          this.$root.$children[0].$refs.refView.loadCheckinDetailData()
        }
      }
      this.checkinFaces = []
      this.faceImgTaken = null
      this.faceImgLivenessTaken = null
      this.checkin = null
      this.takingSelfie = false
      this.detecting = false
      this.photoHasError = false
      this.backBtnOnCameraViewDisabled = false
      this.viewState = undefined
      this.streaming = false

      this.$store.commit('RESET_IS_PREVIEW_CHECKIN')
    },
    beforeConfirm() {
      if (this.livenessDetectionEnabled && this.faceImgTaken) {
        this.viewState = this.modalStates.STATE_ASK_LIVENESS_SELFIE;
        this.takingSelfie = false;

        if (this.faceImgLivenessTaken) {
          this.confirm();
        }
      } else {
        this.confirm();
      }
    },

    async confirm() {
      let formData = new FormData()
      formData.append('face_img', new File([this.faceImgTaken], 'filename.jpeg', {type: 'image/jpeg'}))
      if (this.livenessDetectionEnabled) {
        formData.append('face_img2', new File([this.faceImgLivenessTaken], 'filename2.jpeg', {type: 'image/jpeg'}))
      }

      try {
        this.loading = true
        let response = null
        if (this.stepData.checkin || this.postCheckinMode || this.checkinFaces.length > 0) {
          // Upload extra selfies or 1st one on an existing check-in (e.g. user_cta === 'face-checkin', anonymization)
          response = await this.uploadSelfie({
            id: this.checkin.id,
            payload: formData
          })
        } else {
          // If it's the first selfie, we need to complete the check-in
          const stayDates = this.getEffectiveStayDates()
          if (stayDates.start) formData.append('face_validity_start_at', stayDates.start)
          if (stayDates.end) formData.append('face_validity_end_at', stayDates.end)

          formData.append('consent_share_data_with_owner', this.consentShareDataWithOwner)
          formData.append('consent_privacy', this.acceptPrivacySelfie)
          formData.append('consent_share_policy2', this.acceptSharePolicy2)
          formData.append('consent_share_policy3', this.acceptSharePolicy3)

          response = await this.completeCheckin(formData)
          sessionStorage.removeItem('dateOfStay')
        }

        this.takingSelfie = false
        this.faceImgTaken = null
        this.faceImgLivenessTaken = null

        // API ERROR
        if (!response) {
          return this.handleApiError('try_confirm')
        }

        if (!this.checkin) this.checkin = response.data
        this.checkinFaces = response.data.checkin_faces

        if (this.stepData.max_faces_count > 1 && this.checkinFaces.length < this.stepData.max_faces_count) {
          this.viewState = this.modalStates.STATE_ASK_EXTRA_SELFIE_UPLOAD
        } else {
          this.$bvModal.hide('modal-precheckinfacerecognition')
        }
        this.faceCheckinComplete = true

        const picacode = this.checkin.picacode
        // go to checkin checkins-detail page if I'm not already there
        if (!(this.$route.name === 'checkins-detail' && this.$route.params.picacode === picacode)) {
          await this.$router.push({name: 'checkins-detail', params: {picacode: picacode, msDelay: 2800}})
        }
      } catch (error) {
        if (error instanceof NextStepRequired) {
          await this.openStepModal()
        } else {
          if (!error || !error.response) {
            this.captureUnhandledCompleteCheckinError(error)
            return this.handleApiError("catch_confirm")
          }
          this.faceImgTaken = null
          this.faceImgLivenessTaken = null
          const errorData = error.response.data || {}
          if (errorData.code === 'invalid_user_photo') {
            this.$refs.faceDetector.setInvalidState(
              errorData.detail || this.completeCheckinErrorMessage(errorData.code)
            )
          } else if (errorData.code === 'live_detection_failed') {
            this.$bvToast.toast(this.completeCheckinErrorMessage(errorData.code), {variant: 'warning'})
            this.faceImgTaken = null
            this.faceImgLivenessTaken = null
            this.takingSelfie = false
            this.forceResumeVideo = true
            this.viewState = this.modalStates.STATE_CAMERA

            this.forceResumeVideo = false
          } else if (errorData.code === 'checkin_exists_for_user') {
            await this.openExistingCheckin(error)
          } else if (
            errorData.code === 'precheckin_data_collector_token_expired' ||
            errorData.code === 'precheckin_data_collector_token_invalid' ||
            errorData.code === 'checkin_already_completed'
          ) {
            this.$bvModal.hide('modal-precheckinfacerecognition')
            this.$bvToast.toast(this.completeCheckinErrorMessage(errorData.code), {variant: 'warning'})
          } else {
            this.captureUnhandledCompleteCheckinError(error)
            this.$bvModal.hide('modal-precheckinfacerecognition')
            this.$bvToast.toast(this.completeCheckinErrorMessage(errorData.code), {variant: 'warning'})

          }
          this.photoHasError = true
        }
      } finally {
        this.loading = false
      }
    },

    // SSO provides start/end of stay, but show() only copies them into
    // faceValidity* when stay_mode is set and != NONE. With stay_mode NONE
    // the dates would never be posted, so fall back to the store values
    // here (user-picked dates still take precedence).
    getEffectiveStayDates() {
      const format = date => moment.utc(date.value ? date.value : new Date(date)).format('YYYY-MM-DD')
      const effectiveStart = this.faceValidityStartDate || this.startOfStay
      const effectiveEnd = this.faceValidityEndDate || this.endOfStay
      const start = effectiveStart ? format(effectiveStart) : null
      let end = effectiveEnd ? format(effectiveEnd) : null
      if (!end && start && this.stepData.stay_mode === this.stayMode.SAME_DAY) end = start
      return {start, end}
    },

    // Preflight before asking for the selfie: resolves to false when a check-in
    // already covers the stay (the user is taken there instead). Any other
    // failure lets the flow go on, complete-checkin runs the same check anyway.
    async checkStayReuse() {
      if (this.stepData.checkin || !this.stepData.checkin_id) return true
      const stayDates = this.getEffectiveStayDates()
      if (!stayDates.start && !stayDates.end) return true

      const payload = {}
      if (stayDates.start) payload.start_of_stay = stayDates.start
      if (stayDates.end) payload.end_of_stay = stayDates.end

      try {
        this.loading = true
        await this.validateStay({id: this.stepData.checkin_id, payload})
      } catch (error) {
        const errorData = (error && error.response && error.response.data) || {}
        if (errorData.code === 'checkin_exists_for_user') {
          await this.openExistingCheckin(error)
          return false
        }
        this.captureUnhandledCompleteCheckinError(error)
      } finally {
        this.loading = false
      }
      return true
    },

    async openExistingCheckin(error) {
      this.$bvModal.hide('modal-precheckinfacerecognition')

      const errorData = error.response.data || {}
      const existingPicacode = errorData.error_data && errorData.error_data.picacode
      if (existingPicacode) {
        await this.$router.push({
          name: 'checkins-detail',
          params: {picacode: existingPicacode}
        }).catch(routerError => {
          if (!isNavigationFailure(routerError)) throw routerError
        })
      } else {
        this.captureUnhandledCompleteCheckinError(error)
        this.$bvToast.toast(this.completeCheckinErrorMessage(), {variant: 'warning'})
      }
    },

    completeCheckinErrorMessage(errorCode) {
      const translationKeys = {
        invalid_user_photo: 'modal_pre_checkin_face_recognition.photo_step.no_face_text',
        live_detection_failed: 'notifications.live_detection_failed',
        checkin_exists_for_user: 'notifications.checkin_exists_for_user',
        precheckin_data_collector_token_expired: 'notifications.checkin_token_expired',
        precheckin_data_collector_token_invalid: 'notifications.checkin_token_invalid',
        checkin_already_completed: 'notifications.checkin_already_completed'
      }
      return this.$t(translationKeys[errorCode] || 'notifications.checkin_invalid_code')
    },

    captureUnhandledCompleteCheckinError(error) {
      const response = error && error.response
      const responseData = response && response.data
      const exception = error instanceof Error
        ? error
        : new Error('Unhandled complete-checkin error')

      this.$sentry.captureException(exception, {
        tags: {
          errorType: responseData && responseData.code ? responseData.code : 'unknown',
          location: 'ModalPreCheckinFaceRecognition'
        },
        extra: {
          route: this.$route.name,
          picacode: sessionStorage.getItem('recover_picacode'),
          serverResponse: response ? {
            status: response.status,
            statusText: response.statusText,
            data: responseData
          } : null
        }
      })
    },

    getPrevAndNextStates() {
      let prevState, nextState
      switch (this.viewState) {
          // NEW: START DATE
        case this.modalStates.STATE_ASK_VALIDITY_RANGE_DATE:
          prevState = null

          if (this.stepData.stay_mode !== this.stayMode.NONE && !this.faceValidityStartDate && !this.showEndDateOnlySelector) {
            this.faceValidityStartDateError = true
            nextState = this.modalStates.STATE_ASK_VALIDITY_RANGE_DATE
          } else {
            this.faceValidityStartDateError = false

            // EXCEPTION: only anda date, skip to INFO
            if (this.showEndDateOnlySelector) {
              nextState = this.wasCameraPermissionGrantedWhenOpened ? this.modalStates.STATE_CAMERA : this.modalStates.STATE_INFO
            } else {
              nextState = this.modalStates.STATE_DATES_SUMMARY
            }
          }
          break

          // NEW: DATE SUMMARY
        case this.modalStates.STATE_DATES_SUMMARY:
          prevState = this.modalStates.STATE_ASK_VALIDITY_RANGE_DATE
          nextState = this.wasCameraPermissionGrantedWhenOpened ? this.modalStates.STATE_CAMERA : this.modalStates.STATE_INFO

          break

        case this.modalStates.STATE_INFO:
          prevState = this.stepData.stay_mode === this.stayMode.START_END || this.stepData.stay_mode === this.stayMode.SAME_DAY ? this.modalStates.STATE_ASK_VALIDITY_RANGE_DATE : null
          nextState = this.modalStates.STATE_CAMERA
          break

        case this.modalStates.STATE_CAMERA:
          if (this.checkin) {
            prevState = this.modalStates.STATE_ASK_EXTRA_SELFIE_UPLOAD
          } else if (!this.wasCameraPermissionGrantedWhenOpened) {
            prevState = this.modalStates.STATE_INFO
          } else if (this.stepData.stay_mode === this.stayMode.START_END || this.stepData.stay_mode === this.stayMode.SAME_DAY) {
            prevState = this.modalStates.STATE_ASK_VALIDITY_RANGE_DATE
          } else {
            prevState = null
          }
          if (!this.takingSelfie) {
            nextState = this.modalStates.STATE_CAMERA
          } else if (this.livenessDetectionEnabled) {
            nextState = this.modalStates.STATE_ASK_LIVENESS_SELFIE
          } else if (this.stepData.max_faces_count > 1) {
            nextState = this.modalStates.STATE_ASK_EXTRA_SELFIE_UPLOAD
          } else {
            nextState = null
          }
          break


        case this.modalStates.STATE_ASK_LIVENESS_SELFIE:
          prevState = this.modalStates.STATE_CAMERA

          if (!this.takingSelfie) {
            nextState = this.modalStates.STATE_ASK_LIVENESS_SELFIE
          } else if (this.stepData.max_faces_count > 1) {
            nextState = this.modalStates.STATE_ASK_EXTRA_SELFIE_UPLOAD
          } else {
            nextState = null
          }
          break

        case this.modalStates.STATE_ASK_EXTRA_SELFIE_UPLOAD:
          prevState = null
          nextState = this.checkinFaces.length < this.stepData.max_faces_count ? this.modalStates.STATE_CAMERA : null
          break

        default:
          prevState = null
          nextState = null
          break
      }
      return {prevState, nextState}
    },

    prevStep() {
      const prevState = this.getPrevAndNextStates().prevState
      if (this.viewState === this.modalStates.STATE_CAMERA) {
        this.faceImgTaken = null
        this.faceImgLivenessTaken = null
        this.takingSelfie = false
      }
      if (prevState === null) {
        this.$bvModal.hide('modal-precheckinfacerecognition')
        return
      }
      this.viewState = prevState
    },

    async nextStep() {
      const nextState = this.getPrevAndNextStates().nextState
      // Last "continue" of the dates part (the summary, or the dates step itself
      // with only-end): check the stay before moving on to the selfie part
      const {STATE_ASK_VALIDITY_RANGE_DATE, STATE_DATES_SUMMARY, STATE_INFO, STATE_CAMERA} = this.modalStates
      const isOnDatesStep = [STATE_ASK_VALIDITY_RANGE_DATE, STATE_DATES_SUMMARY].includes(this.viewState)
      const isSelfieNext = [STATE_INFO, STATE_CAMERA].includes(nextState)
      if (isOnDatesStep && isSelfieNext && !await this.checkStayReuse()) return
      if (nextState === this.modalStates.STATE_CAMERA || nextState === this.modalStates.STATE_ASK_LIVENESS_SELFIE) {
        if (this.viewState === nextState) {
          this.takingSelfie = true
          this.detecting = true
        } else {
          this.faceImgTaken = null
          this.faceImgLivenessTaken = null
        }
      } else {
        this.backBtnOnCameraViewDisabled = false
      }
      this.viewState = nextState
    },

    onPhotoRetake(args) {
      this.photoHasError = args && args.error
      this.takingSelfie = false
      this.detecting = false
      this.faceImgTaken = null
      this.faceImgLivenessTaken = null
      this.$refs.faceDetector.resumeVideo()
    },

    onPhotoTaken({faceImg, isLiveness}) {
      if (this.livenessDetectionEnabled && isLiveness) {
        this.faceImgLivenessTaken = faceImg
      } else {
        this.faceImgTaken = faceImg
      }
      this.detecting = false
    },

    async isCameraPermissionGranted() {
      const devices = await navigator.mediaDevices.enumerateDevices()
      for (const device of devices) {
        if (device.kind !== 'videoinput') continue
        if (device.label) return true
      }
      console.log('Camera permissions not granted!')
      return false
    },

    async handleApiError(data) {
      this.$bvModal.hide('modal-precheckinfacerecognition')
      this.$bvToast.toast(this.$t('notifications.checkin_server_error'), {variant: 'danger'})
      this.loading = false
      await this.$router.push({
        name: 'checkin-error',
        query: {
          error: checkinErrors.SERVER_ERROR,
          picacode: sessionStorage.getItem('recover_picacode'),
          data: data
        }
      }).catch(error => {
        if (!isNavigationFailure(error)) throw error
      })
      return false
    },

    onStreamAllowed() {
      this.streaming = true
    },
    async onStreamNotAllowed() {
      this.$bvModal.hide('modal-precheckinfacerecognition')
      this.$bvToast.toast(this.$t('notifications.camera_permission_denied'), {variant: 'danger'})
      await this.$router.push({
        name: 'checkin-error',
        query: {
          error: checkinErrors.CAMERA_PERMISSION_DENIED,
          picacode: sessionStorage.getItem('recover_picacode')
        }
      }).catch(error => {
        if (!isNavigationFailure(error)) throw error
      })
    },
    onCameraSwitch() {
      this.streaming = false
      this.$refs.faceDetector.switchCamera()
    }

  }
}
</script>
